var React = require('react');

function PauseIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M272 63.1l-32 0c-26.51 0-48 21.49-48 47.1v288c0 26.51 21.49 48 48 48L272 448c26.51 0 48-21.49 48-48v-288C320 85.49 298.5 63.1 272 63.1zM80 63.1l-32 0c-26.51 0-48 21.49-48 48v288C0 426.5 21.49 448 48 448l32 0c26.51 0 48-21.49 48-48v-288C128 85.49 106.5 63.1 80 63.1z"}));
}

PauseIconInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 320 512"};

module.exports = PauseIconInline;

PauseIconInline.default = PauseIconInline;
